/**
 * API клієнт для ref.nomenclature_specifications (виробничий блок).
 *
 * Backend endpoints: /api/v1/nomenclature-specifications (Порція Виробництво.2).
 * Permission: production.specification.manage (на всі операції — GET теж під manage).
 */
import { api } from './client';
import type { Page } from './catalogs';

// Призначення специфікації (1С УТП «Назначение», alembic 0262):
// PRODUCTION — виробнича рецептура; ASSEMBLY — склад набору/комплекту.
export type SpecificationPurpose = 'PRODUCTION' | 'ASSEMBLY';

export interface NomenclatureSpecificationItemIn {
  line_number: number;
  raw_material_nomenclature_id: string;
  quantity: string;
  uom_id?: string | null;
  comment?: string | null;
  // Доля собівартості % — обов'язкова для ASSEMBLY (сума=100), NULL для PRODUCTION.
  cost_percentage?: string | null;
}

export interface NomenclatureSpecificationItem extends NomenclatureSpecificationItemIn {
  id: string;
}

export interface NomenclatureSpecificationListItem {
  id: string;
  organization_id: string;
  product_nomenclature_id: string;
  base_quantity: string;
  name: string;
  purpose: SpecificationPurpose;
  is_active: boolean;
  valid_from: string;
  valid_to: string | null;
  deletion_mark: boolean;
}

export interface NomenclatureSpecification extends NomenclatureSpecificationListItem {
  description: string | null;
  created_at: string;
  created_by: string | null;
  items: NomenclatureSpecificationItem[];
}

export interface NomenclatureSpecificationCreate {
  organization_id: string;
  product_nomenclature_id: string;
  base_quantity: string;
  name: string;
  description?: string | null;
  purpose?: SpecificationPurpose;
  is_active?: boolean;
  items?: NomenclatureSpecificationItemIn[];
}

export type NomenclatureSpecificationUpdate = Partial<Omit<NomenclatureSpecificationCreate, 'organization_id'>>;

export const nomenclatureSpecifications = {
  list: (params?: {
    organization_id?: string;
    product_nomenclature_id?: string;
    purpose?: SpecificationPurpose;
    is_active?: boolean;
    limit?: number;
    offset?: number;
  }) =>
    api.get<Page<NomenclatureSpecificationListItem>>('/nomenclature-specifications', { params })
      .then((r) => r.data),
  get: (id: string) =>
    api.get<NomenclatureSpecification>(`/nomenclature-specifications/${id}`).then((r) => r.data),
  create: (payload: NomenclatureSpecificationCreate) =>
    api.post<NomenclatureSpecification>('/nomenclature-specifications', payload).then((r) => r.data),
  update: (id: string, payload: NomenclatureSpecificationUpdate) =>
    api.patch<NomenclatureSpecification>(`/nomenclature-specifications/${id}`, payload).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`/nomenclature-specifications/${id}`).then(() => undefined),
};
